import { z } from 'zod'
import { SOCIAL_CHANNELS } from '../../../../convex/lib/lead_attribution'

const tag=z.string().trim().max(100,'Máximo 100 caracteres.').regex(/^[a-z0-9]+(?:[_-][a-z0-9]+)*$/,'Usa minúsculas, números, guiones o guiones bajos.')
export function campaignDestination(input:string):URL {
  const url=new URL(input,'https://a1homes.es')
  if(url.origin!=='https://a1homes.es'||url.username||url.password||!input.trim())throw new z.ZodError([{code:'custom',path:['destination'],message:'Destino fuera de A1Homes'}])
  return url
}
export const campaignSchema=z.object({
  destination:z.string().trim().refine(value=>{try{campaignDestination(value);return true}catch{return false}},'Introduce una URL HTTPS de a1homes.es o una ruta del sitio.'),
  source:z.enum(['instagram','linkedin','youtube','facebook','tiktok','x']),medium:z.enum(['social','paid_social']),
  campaign:tag,content:z.union([tag,z.literal('')]),term:z.union([tag,z.literal('')]),
})
export type CampaignInput=z.infer<typeof campaignSchema>
export function buildCampaignLink(input:CampaignInput):string {
  const valid=campaignSchema.parse(input),url=campaignDestination(valid.destination)
  for(const key of ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'])url.searchParams.delete(key)
  url.searchParams.set('utm_source',valid.source);url.searchParams.set('utm_medium',valid.medium);url.searchParams.set('utm_campaign',valid.campaign)
  if(valid.content)url.searchParams.set('utm_content',valid.content)
  if(valid.term)url.searchParams.set('utm_term',valid.term)
  return url.href
}
export { SOCIAL_CHANNELS }
